<template>
  <ul
    v-if="isHomeVersionBar"
    class="type-toggle nav nav-fill nav-pills"
    id="pills-tab"
    role="tablist"
  >
    <v-sheet
      class="mx-auto slider-width"
      max-width="100%"
      width="100%"
      style="background: none"
    >
      <v-slide-group
        multiple
        show-arrows="mobile"
        class="menu-center align-items-center"
      >
        <template v-for="(menu, index) in sortedMenuList">
          <v-slide-item
            :key="`food${index}`"
            class="px-2"
            v-slot:default="{ active }"
            v-if="
              menu !== undefined &&
                menu.type === 'principal' &&
                menu.id === productTypeIds.food &&
                !disableAddFood &&
                displayComidas() &&
                validFood
            "
          >
            <v-btn
              class="mb-2 bar-slider-btn"
              :input-value="active"
              depressed
              :ripple="false"
              :class="{ active: !isActive }"
              @click="onTab(productTypeIds.food)"
            >
              {{ $t("common.food") }}
            </v-btn>
          </v-slide-item>

          <v-slide-item
            :key="`drinks${index}`"
            class="px-2"
            v-slot:default="{ active, toggle }"
            v-if="
              menu !== undefined &&
                menu.type === 'principal' &&
                menu.id === productTypeIds.drinks &&
                !disableAddDrinks &&
                displayBebidas() &&
                validDrinks
            "
          >
            <v-btn
              class="mb-2 bar-slider-btn"
              depressed
              :input-value="active"
              :ripple="false"
              :class="{ active: isActive }"
              @click="
                onTab(productTypeIds.drinks);
                toggle;
              "
            >
              {{ $t("common.drinks") }}
            </v-btn>
          </v-slide-item>
          <v-slide-item
            :key="`dessert${index}`"
            class="px-2"
            v-slot:default="{ active }"
            v-if="
              menu !== undefined &&
                menu.type === 'principal' &&
                menu.id === productTypeIds.dessert &&
                !disableAddDessert &&
                displayPostres() &&
                validDessert
            "
          >
            <v-btn
              class="mb-2 bar-slider-btn"
              :input-value="active"
              depressed
              :ripple="false"
              :class="{ active: !isActive }"
              @click="onTab(productTypeIds.dessert)"
            >
              {{ $t("common.dessert") }}
            </v-btn>
          </v-slide-item>
        </template>
      </v-slide-group>
    </v-sheet>
  </ul>
</template>

<script>
export default {
  name: "BarSlider",
  props: [
    "menus",
    "menuGroup",
    "productByCategory",
    "scheduleByMenu",
    "scheduleByMenuGroup",
    "disableAddFood",
    "disableAddDrinks",
    "disableAddDessert",
    "drinks",
    "food",
    "dessert",
    "sortedMenuList",
    "validFood",
    "validDrinks",
    "validDessert"
  ],
  data() {
    return {
      isActive: true
    };
  },
  methods: {
    disableMenuBySchedule(menu) {
      let menuSchedule = this.scheduleByMenu.find(x => x.menuId === menu.id);
      return menuSchedule ? this.disableMenu(menuSchedule.schedule) : false;
    },
    disableMenuGroup(menu) {
      let menuSchedule = this.scheduleByMenuGroup.find(
        x => x.menuId === menu.id
      );
      return menuSchedule ? this.disableMenu(menuSchedule.schedule) : false;
    },
    onTab(Id) {
      this.$emit("onTab", Id);
      this.isActive = !this.isActive;
    },
    selectColor(menu) {
      this.$emit("setColor", menu);
    },
    onCategoryTab(categoryId) {
      this.$emit("onCategoryTab", categoryId);
    },
    onMenuGroupTab(menuGroupId) {
      this.$emit("onMenuGroupTab", menuGroupId);
    }
  }
};
</script>

<style scoped lang="scss"></style>
